var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 11.1667H15.3327V12.5H0.666016V11.1667H1.99935V1.16667C1.99935 0.989856 2.06959 0.820286 2.19461 0.695262C2.31964 0.570238 2.4892 0.5 2.66602 0.5H9.33268C9.50949 0.5 9.67906 0.570238 9.80409 0.695262C9.92911 0.820286 9.99935 0.989856 9.99935 1.16667V11.1667H12.666V5.83333H11.3327V4.5H13.3327C13.5095 4.5 13.6791 4.57024 13.8041 4.69526C13.9291 4.82029 13.9993 4.98986 13.9993 5.16667V11.1667ZM3.33268 1.83333V11.1667H8.66602V1.83333H3.33268ZM4.66602 5.83333H7.33268V7.16667H4.66602V5.83333ZM4.66602 3.16667H7.33268V4.5H4.66602V3.16667Z",
    fill: "#303536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLocation);
export default __webpack_public_path__ + "static/media/address-location.4361e6b0bb9c6b50bff35cf13a8ab799.svg";
export { ForwardRef as ReactComponent };